import React from "react";
import LineChart from "./LineChart";
import { fmtUSD } from "../utils/format";

type CommitmentsCardProps = {
  months?: any[];
  series?: unknown[]; // whatever your LineChart expects
};

export function CommitmentsCard({
  months = [],
  series = [],
}: CommitmentsCardProps) {
  const hasData = months.length > 0 && series.length > 0;

  if (!hasData) {
    return (
      <div className="rounded-2xl border border-slate-200 bg-white/90 shadow-sm flex flex-col p-4 text-xs text-slate-500">
        <div className="mb-1 text-sm font-semibold text-slate-900">
          Active RegCF companies
        </div>
        <div>No active RegCF commitments yet.</div>
      </div>
    );
  }

  return (
    <div className="rounded-2xl border border-slate-200 bg-white/90 shadow-sm flex flex-col">
      <div className="px-4 py-3 border-b border-slate-100 bg-slate-50 flex items-center justify-between">
        <div className="text-sm font-semibold text-slate-900">
          Active RegCF companies
        </div>
        <div className="text-[11px] text-slate-500">
          Last {months.length} months
        </div>
      </div>

      {/* Month list with totals + active counts */}
      <div className="divide-y divide-slate-100">
        {months.map((m) => (
          <div
            key={m.label}
            className="px-4 py-3 flex items-center justify-between"
          >
            <div className="flex flex-col">
              <div className="text-xs text-slate-700">{m.label}</div>
              {m.count != null && (
                <div className="text-[11px] text-slate-400">
                  {m.count} active deal{m.count === 1 ? "" : "s"}
                </div>
              )}
            </div>
            <div className="text-xs bg-indigo-50 text-indigo-700 rounded-full px-3 py-1 font-medium">
              {fmtUSD(m.value)}
            </div>
          </div>
        ))}
      </div>

      {/* Chart */}
      <div className="px-3 pb-3 pt-1">
        <LineChart data={series} />
      </div>
    </div>
  );
}
